"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Icon = _styledComponents["default"].svg.attrs({
  role: 'presentation'
}).withConfig({
  displayName: "Icon",
  componentId: "sc-36vrnf-0"
})(["display:block;fill:currentColor;width:16px;height:16px;user-select:none;"]);

var _default = Icon;
exports["default"] = _default;